export interface IStandardSummaryRequest {
  standardSummaryTypeId: number;
  month: number;
  quarter: number;
  year: number;
  db: number;
  countyCode?: string;
  cityCode?: string;
  grouping?: StandardSummaryGrouping;
}

export enum StandardSummaryGrouping {
  County = 0,
  City = 1,
  AlcoholInvolvedAll = 2,
  AlcoholInvolvedOnly = 3,
  CountyRoadTrafficCrashes = 4,
  DoubleBottomCrashesAll = 5,
  DoubleBottomCrashesOnly = 6,
  FarmEquipmentCrashesAll = 7,
  FarmEquipmentCrashesOnly = 8,
  FederalDefinitionRural = 9,
  FederalDefinitionUrban = 10,
  HeavyTruckAndBusAll = 11,
  HeavyTruckAndBusOnly = 12,
  InterstateCrashesAll = 13,
  MotorVehicleTrainCrashes = 14,
  MotorizedCycleCrashes = 15,
  AtvRovCrashesAll = 16,
  AtvRovCrashesOnly = 17,
  PedalcycleCrashesAll = 18,
  PedalcycleCrashesOnly = 19,
  PedestrianCrashesAll = 20,
  PedestrianCrashesOnly = 21,
  SchoolBusCrashesAll = 22,
  SchoolBusCrashesOnly = 23,
  SchoolBusRelated = 24,
  StateHighwayTrafficCrashes = 25,
  StatewideTrafficCrashes = 26,
  TeenageDriverCrashesAll = 27,
  TeenageDriverCrashesOnly = 28,
  TractorTrailerCrashesAll = 29,
  TractorTrailerCrashesOnly = 30,
  YoungDriverCrashesAll = 31,
  YoungDriverCrashesOnly = 32,
  Nighttime = 33,
  RuralNighttime = 34,
  UrbanNighttime = 35,
  YearToDate = 36,
}

export interface GenerateStandardSummaryRequest {
  standardSummaryTypeId: number;
  month: number;
  quarter: number;
  year: number;
  db: number;
}
